// vim: set ts=2 sts=2 sw=2 et:

const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);

export const isLoopbackHost = (host: string | null | undefined): boolean => {
  if (host === null || host === undefined || host.length === 0) {
    return true;
  }

  return LOOPBACK_HOSTS.has(host.toLowerCase());
};

const rewriteWebSocketUrl = (wsUrl: string, lanHost: string): string => {
  try {
    const parsed = new URL(wsUrl);
    if (!isLoopbackHost(parsed.hostname)) {
      return wsUrl;
    }

    parsed.hostname = lanHost;
    return parsed.toString();
  } catch (_error) {
    return wsUrl;
  }
};

export const rewriteUrlForLanAccess = (url: string, lanHost: string | null | undefined): string => {
  if (lanHost === null || lanHost === undefined || lanHost.length === 0 || isLoopbackHost(lanHost)) {
    return url;
  }

  try {
    const parsed = new URL(url, "http://localhost");
    if (!isLoopbackHost(parsed.hostname)) {
      return url;
    }

    parsed.hostname = lanHost;

    const wsParam = parsed.searchParams.get("ws");
    if (wsParam !== null && wsParam.length > 0) {
      parsed.searchParams.set("ws", rewriteWebSocketUrl(wsParam, lanHost));
    }

    return parsed.toString();
  } catch (_error) {
    return url;
  }
};

export const choosePreferredLanHost = (
  currentHost: string | null | undefined,
  suggestedHosts: ReadonlyArray<string> | null | undefined,
): string => {
  if (!isLoopbackHost(currentHost) && currentHost !== null && currentHost !== undefined && currentHost.length > 0) {
    return currentHost;
  }

  const firstSuggested = suggestedHosts?.find((host) => host.length > 0 && !isLoopbackHost(host));
  return firstSuggested || currentHost || "127.0.0.1";
};
